import { EventHandler } from '../event-handler'

export class EventTrackerContextCleaner extends EventHandler {
  /**
   * Cleans the specified event properties from the global fpti object.
   * @param {Record<string, string | number | boolean>} event - The event object containing properties to be cleaned.
   */
  clean(event) {
    Object.keys(event).forEach((key) => {
      delete window.fpti[key]
    })
  }

  /**
   * Handles the event cleaning process.
   * @param {import("../event").Event} event - The event object to be handled.
   */
  handle(event) {
    this.clean(event.getPayload())
    super.handle(event)
  }
}
